import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';

import { Tooltip } from '@alkem/react-ui-tooltip';

interface Props {
  label: string;
  help: string;
}

export function AuthFormLabelWithHelp({ label, help }: Props) {
  const id = useMemo(() => `label-help-${uuid()}`, []);
  return (
    <span className="AuthFormLabelWithHelp">
      {label}&nbsp;
      <i className="mdi mdi-help-circle" data-for={id} data-tip />
      <Tooltip id={id}>{help}</Tooltip>
    </span>
  );
}
